import React from 'react';

export type SortOrder = 'ASC' | 'DESC';

interface SortableTabHeaderProps {
    label: React.ReactNode;
    columnName: string;
    column: string;
    order: SortOrder;
    setColumn: React.Dispatch<React.SetStateAction<string>>;
    setOrder: React.Dispatch<React.SetStateAction<SortOrder>>;
    setPageNumber?: React.Dispatch<React.SetStateAction<number>>;
    setFetchData?: React.Dispatch<React.SetStateAction<number>>;
    className?: string;
    style?: React.CSSProperties;
}

const SortableTabHeader = (props: SortableTabHeaderProps): JSX.Element => {
    const {
        label,
        columnName,
        column,
        order,
        setColumn,
        setOrder,
        setPageNumber,
        setFetchData,
        className,
        style,
    } = props;

    const isActiveColumn = column === columnName;

    const handleSort = (): void => {
        const nextOrder: SortOrder = isActiveColumn && order === 'ASC'
            ? 'DESC'
            : 'ASC';

        setColumn(columnName);
        setOrder(nextOrder);
        setPageNumber?.(1);
        setFetchData?.(Date.now());
    };

    return (
        <th
            className={className}
            style={{
                background: '#F3F3F3',
                verticalAlign: 'middle',
                cursor: 'pointer',
                userSelect: 'none',
                ...style,
            }}
            onClick={handleSort}
        >
            {label}
            <br />

            <span
                className="material-icons"
                style={{
                    verticalAlign: 'middle',
                    opacity: isActiveColumn && order === 'ASC' ? 1 : 0.35,
                }}
            >
                expand_less
            </span>

            <span
                className="material-icons"
                style={{
                    verticalAlign: 'middle',
                    opacity: isActiveColumn && order === 'DESC' ? 1 : 0.35,
                }}
            >
                expand_more
            </span>
        </th>
    );
};

export default SortableTabHeader;